var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.756,
    height: 18.348,
    viewBox: "0 0 18.756 18.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(131.746 80.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2083",
    "data-name": "Raggruppa 2083",
    transform: "translate(-131.746 -80.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3494",
    "data-name": "Tracciato 3494",
    d: "M13.957.261a1.8,1.8,0,0,1-.306,1.476c-.545.874-4.327,4.012-4.407,4.47,1.035,1.317,1.676,1.872,1.136,3.716L4.848,18.251c-.652.346-1.179-.213-1.675-.613-2.553-2.061-4.966-5.249-7.408-7.522a3.8,3.8,0,0,1-.51-.7c-.009-.123.026-.078.632-.475l8-5.3c1.669-.635,2.678.182,3.911,1.114.577-.1,3.813-4.234,4.683-4.632a1.753,1.753,0,0,1,1.48.136Zm-5.6,9.7c.342-.913.524-1.1-.1-1.955A25.85,25.85,0,0,0,5.49,5.364c-.533-.2-.954.258-1.45.278-.1.372.155.431.322.648a30.987,30.987,0,0,0,3.351,3.35C7.929,9.805,7.987,10.058,8.36,9.961ZM4.468,15.8l2.562-4L2.2,6.971C1.018,7.886-.312,8.6-1.526,9.473c-.151.108-.369-.046-.268.374l1.214,1.18C.525,10.459.774,9.164,2.28,9.99c.344,1.28-.788,1.706-1.253,2.645a30.7,30.7,0,0,0,2.9,2.953c.182.126.227.295.541.21Z",
    transform: "translate(4.746 -0.011)",
    fill: "#b91f26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClean);
export default __webpack_public_path__ + "static/media/icon-clean.88666070a1de9779aab68f5a09f7a296.svg";
export { ForwardRef as ReactComponent };